// const axios = require('axios');
import axios from 'axios';

async function makeGetRequestToUrl(url, params, headers, timeout) {
    // Set defaults inside the function
    headers = headers || { 'Content-Type': 'application/json' };
    timeout = timeout || 5000;

    try {
        const response = await axios({
            method: 'GET',
            url: url,
            params: params,
            headers: headers,  // Use provided headers or default to JSON
            timeout: timeout   // Default timeout set to 5 seconds
        });
        return response.data;  // Return the data from the response
    } catch (error) {
        handleHttpError(error, url);
        throw error;  // Re-throw the error for the calling code to handle
    }
}

async function makePostRequestToUrl(url, data, headers, timeout) {
    // Set defaults inside the function
    data = data || {};
    headers = headers || { 'Content-Type': 'application/json' };
    timeout = timeout || 5000;

    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: data,        // Use provided data or default to empty object
            headers: headers,  // Use provided headers or default to JSON
            timeout: timeout   // Default timeout set to 5 seconds
        });

        return response.data;  // Return the data from the response
    } catch (error) {
        handleHttpError(error, url);
        throw error;  // Re-throw the error for the calling code to handle
    }
}

// Helper function to handle errors for HTTP requests
function handleHttpError(error, url) {
    console.error(`Error calling endpoint at ${url}: ${error.message}`);

    if (error.response) {
        // If the server responded with a status code out of the 2xx range
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
    } else if (error.request) {
        // If the request was made but no response was received
        console.error('No response received:', error.request);
    } else {
        // Something else happened during the request setup
        console.error('Error setting up the request:', error.message);
    }
}

export {
    makeGetRequestToUrl,
    makePostRequestToUrl
};